/* eslint-disable */
import React from 'react';

import './compositeList.css';


export const ActionBar = (props) => {
  return (
    <div className="right-section">
      <div className="gdocs-float-left">
        <span className="status-text">{props.status}</span>
        <span className="status-icon"><i className={props.iconClass}></i></span>
      </div>
      {
        props.hideActionButton ? '' : (
          <div className="gdocs-float-left">
            <a className="action-button"
               tabIndex="0"
               onClick={(e) => {props._onClick(e, props.eventReply)}}
               onKeyPress={(e) => {e.key === 'Enter' ? props._onClick(e, props.eventReply) : ''}} >
              <i className="icon icon-bin"></i>
            </a>
          </div>
        )
      }
      <div className="gdocs-clear-float"></div>
    </div>
  );
}

export const ItemHeading = (props) => {

  return (
    <div className="list-item-heading" onClick={(event) => props._onClick(event, props.id ,props.lid)}>
    {props.children}
    <i className="icon icon-chevron-right"></i>
    </div>
  )
}

export const ItemSubHeading = (props) => {
  return (<div className="list-item-sub-heading">{props.children}</div>)
}

export const ListRightContentSection = (props) => {
  return (
    <div className="left-section">
      {props.children}
    </div>
  );
}

export const ListMiddleContentSection = (props) => {
  return (
    <div className="middle-section">
      {props.children}
    </div>
  )
}

export const CompositeListItem = (props) => {
  return (
    <li className="composite-list-item">
      {props.children}
    </li>
  );
}

export const CompositeList = (props) => {
  return (
    <ul className="composite-list">
      {props.children}
    </ul>
  );
}



// WEBPACK FOOTER //
// ./src/components/common/CompositeList/compositeList.js